import AFrenchChristmas from '@/views/events/AFrenchChristmas'
import ATasteOfAutumn from '@/views/events/ATasteOfAutumn'
import About from '@/views/About'
import BeetTheJanuaryBlues from '@/views/events/BeetTheJanuaryBlues'
import Collaborations from '@/views/services/Collaborations'
import Contact from '@/views/Contact'
import CookingClasses from '@/views/services/CookingClasses'
import Page from '@/components/Page'
import EBooks from '@/views/EBooks'
import EventCatering from '@/views/services/EventCatering'
import Events from '@/views/Events'
import EventsEvents from '@/views/events/EventsEvents'
import Gallery from '@/views/Gallery'
import GiftsFromTheWholesomeKitchen from '@/views/events/GiftsFromTheWholesomeKitchen'
import HealthySnacks from '@/views/services/HealthySnacks'
import Home from '@/views/Home'
import HomeDeliveries from '@/views/services/HomeDeliveries'
import IntroductionToSourdough from '@/views/events/IntroductionToSourdough'
import LastOfTheSummerVeg from '@/views/events/LastOfTheSummerVeg'
import OnlineLearning from '@/views/OnlineLearning'
import Privacy from '@/views/Privacy'
import PersonalChef from '@/views/services/PersonalChef'
import Recipe from '@/views/Recipe'
import Recipes from '@/views/Recipes'
import RetreatCatering from '@/views/services/RetreatCatering'
import RetreatSpring from '@/views/events/retreats/RetreatSpring'
import Retreats from '@/views/events/retreats/Retreats'
import Services from '@/views/Services'
import Shop from '@/views/Shop'
import Supperclubs from '@/views/events/Supperclubs'
import Terms from '@/views/Terms'
import TheMagicOfFermentation from '@/views/events/TheMagicOfFermentation'
import Unsubscribe from '@/views/Unsubscribe'
import Workshops from '@/views/events/workshops/Workshops'

export const routes = [
  {
    path: '/',
    component: Home,
    name: 'home'
  },
  {
    path: '/about',
    component: About,
    name: 'about'
  },
  {
    path: '/services',
    component: Services,
    name: 'services',
    redirect: '/work-with-me'
  },
  {
    path: '/work-with-me',
    component: Services,
    name: 'work-with-me'
  },
  {
    path: '/services/retreat-catering',
    component: RetreatCatering,
    name: 'retreat-catering'
  },
  {
    path: '/services/event-catering',
    component: EventCatering,
    name: 'event-catering'
  },
  {
    path: '/services/cookery-lessons',
    component: CookingClasses,
    name: 'cookery-lessons',
    redirect: '/services/cooking-classes'
  },
  {
    path: '/services/cooking-classes',
    component: CookingClasses,
    name: 'cooking-classes'
  },
  {
    path: '/services/private-chef',
    component: PersonalChef,
    name: 'private-chef',
    redirect: '/services/personal-chef',
  },
  {
    path: '/services/personal-chef',
    component: PersonalChef,
    name: 'personal-chef',
  },
  {
    path: '/services/wellness-collaborations',
    component: Collaborations,
    name: 'wellness-collaborations',
    redirect: '/services/collaborations',
  },
  {
    path: '/services/collaborations',
    component: Collaborations,
    name: 'collaborations',
  },
  {
    path: '/services/healthy-snacks-orders',
    component: HealthySnacks,
    name: 'healthy-snacks',
    redirect: '/services/home-deliveries',
  },
  {
    path: '/services/home-deliveries',
    component: HomeDeliveries,
    name: 'home-deliveries'
  },
  // Gallery
  {
    path: '/gallery',
    component: Gallery,
    name: 'gallery',
  },
  // Events
  {
    path: '/events',
    component: Events,
    name: 'events',
  },
  {
    path: '/events/cooking-workshops',
    component: Workshops,
    name: 'cooking-workshops'
  },
  {
    path: '/events/events',
    component: EventsEvents,
    name: 'events-events'
  },
  {
    path: '/events/holistic-retreats',
    component: Retreats,
    name: 'holistic-retreats'
  },
  {
    path: '/events/supperclubs',
    component: Supperclubs,
    name: 'supperclubs'
  },
  // Workshop Events
  {
    path: '/events/introduction-to-sourdough',
    component: IntroductionToSourdough,
    name: 'introduction-to-sourdough',
    redirect: '/events/sourdough-masterclass',
  },
  {
    path: '/events/sourdough-masterclass',
    component: IntroductionToSourdough,
    name: 'sourdough-masterclass',
  },
  {
    path: '/events/the-magic-of-fermentation',
    component: TheMagicOfFermentation,
    name: 'the-magic-of-fermentation',
  },
  // Retreat Events
  {
    path: '/events/retreats/spring',
    component: RetreatSpring,
    name: 'retreat-spring'
  },
  // Past Events
  {
    path: '/events/gifts-from-the-wholesome-kitchen',
    component: GiftsFromTheWholesomeKitchen,
    name: 'gifts-from-the-wholesome-kitchen',
    redirect: '/events',
  },
  {
    path: '/events/last-of-the-summer-veg',
    component: LastOfTheSummerVeg,
    name: 'last-of-the-summer-veg',
    redirect: '/events',
  },
  {
    path: '/events/a-taste-of-autumn',
    component: ATasteOfAutumn,
    name: 'a-taste-of-autumn',
    redirect: '/events',
  },
  {
    path: '/events/a-french-christmas',
    component: AFrenchChristmas,
    name: 'a-french-christmas',
    redirect: '/events',
  },
  {
    path: '/events/beet-the-january-blues',
    component: BeetTheJanuaryBlues,
    name: 'beet-the-january-blues'
  },
  {
    path: '/events/:eventId',
    component: Page,
    name: 'event-page',
    props: true,
  },
  // Shop
  {
    path: '/shop',
    component: Shop,
    name: 'shop'
  },
  {
    path: '/ebooks',
    component: EBooks,
    name: 'ebooks',
  },
  {
    path: '/online-learning',
    component: OnlineLearning,
    name: 'online-learning',
  },
  // Recipes
  {
    path: '/recipes',
    component: Recipes,
    name: 'recipes',
    redirect: '/blog',
  },
  {
    path: '/blog',
    component: Recipes,
    name: 'blog'
  },
  {
    path: '/recipes/:pageId',
    component: Recipe,
    props: true,
    redirect: '/blog/:pageId',
  },
  {
    path: '/blog/:pageId',
    component: Recipe,
    props: true,
  },
  {
    path: '/unsubscribe',
    component: Unsubscribe,
    props: (route) => ({ email: route.query.email }),
    name: 'unsubscribe'
  },
  {
    path: '/contact',
    component: Contact,
    props: (route) => ({ subject: route.query.subject }),
    name: 'contact'
  },
  {
    path: '/privacy',
    component: Privacy,
    name: 'privacy'
  },
  {
    path: '/terms-and-conditions',
    component: Terms,
    name: 'terms'
  },
  {
    path: '*',
    redirect: '/'
  }
]
